module.exports = "/_next/static/images/video_id_7151489451510779178-66e8c31ec5372febc09ccb6484f86835.jpg";